import "./CoalitionSection.scss";

export const CoalitionSection = ({ title, subtitle, children }) => (
  <div className="generic-section">
    <div className="title">{title}</div>
    <div className="subtitle">{subtitle}</div>
    <div className="cards">{children}</div>
  </div>
);
